import type { ProductDrawerViewModel } from "shared-ui/src/components/ecommerce/product-detail-drawer/types";

export function preserveSavedLinePrice(
  enrichedProduct: ProductDrawerViewModel | null,
  savedLinePrice: number | null | undefined,
): ProductDrawerViewModel | null {
  return enrichedProduct
    ? { ...enrichedProduct, price: savedLinePrice }
    : null;
}
